// =========================================================
// HERO — retrait parallax du contenu au scroll (scrub ScrollTrigger).
// Le rideau lui-même est en CSS pur (hero sticky + sections z-index 1) :
// ici on ajoute seulement la profondeur — le contenu s'estompe et remonte
// pendant que la section suivante recouvre le hero.
// Règle d'or respectée : gsap.to uniquement (jamais gsap.from).
// =========================================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('.km-hero');
    if (!hero || hero.dataset.kmParallaxInitialized) return;
    hero.dataset.kmParallaxInitialized = '1';

    // Bas du hero DANS LE FLUX : l'ancre #km-suite posée juste après lui (section-hero.php).
    // ⚠️ Pas hero.offsetTop : sur un élément sticky, Chrome le fait varier pendant qu'il colle
    // (0 en haut, 2760 en bas de page, mesuré le 28/10).
    const anchor = hero.nextElementSibling && hero.nextElementSibling.classList.contains('km-hero-anchor')
        ? hero.nextElementSibling : null;
    const heroEnd = () => (anchor ? anchor.offsetTop : hero.offsetHeight);
    const heroStart = () => heroEnd() - hero.offsetHeight;

    gsap.to('.km-hero__content, .km-hero__scroll', {
        opacity: 0,
        y: -50,
        ease: 'none',
        // ⚠️ Seuils en POSITIONS DE DÉFILEMENT calculées sur le flux (heroStart / heroEnd),
        // jamais `trigger: hero` : le hero est sticky, sa position à l'écran ne bouge pas une fois
        // collé, et un refresh de ScrollTrigger fait en cours de défilement (images chargées,
        // barre d'adresse mobile qui redimensionne) recalculait les seuils au mauvais endroit
        // (vécu 28/10 : en remontant, le contenu restait estompé et la vidéo cachée).
        scrollTrigger: {
            start: () => heroStart(),
            end: () => heroStart() + hero.offsetHeight * .7,
            scrub: true,
            invalidateOnRefresh: true,
        },
    });

    // ----- Hero ENTIÈREMENT recouvert → visibility:hidden + vidéo en pause -----
    // La couche GPU de la vidéo sticky peut PERCER à travers les fonds opaques
    // des sections (bug d'ordre de composition Chrome, vécu : la vidéo visible
    // dans les encoches des coins arrondis de services). Un hero masqué n'a
    // plus AUCUNE couche à composer → plus rien ne perce, et on économise le
    // décodage vidéo sur tout le reste de la page.
    const video = hero.querySelector('video');
    const setCovered = (covered) => {
        hero.style.visibility = covered ? 'hidden' : '';
        if (video) {
            if (covered && !video.paused) video.pause();
            if (!covered && video.paused && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                video.play().catch(() => {});
            }
        }
    };
    // Le hero est recouvert après un défilement égal à sa hauteur (position de flux, cf. plus haut).
    // onRefresh resynchronise l'état : après un recalcul, il ne peut plus rester masqué en haut de page.
    ScrollTrigger.create({
        start: () => heroEnd(),
        end: 'max',
        invalidateOnRefresh: true,
        onEnter: () => setCovered(true),
        onLeaveBack: () => setCovered(false),
        onRefresh: (self) => setCovered(self.scroll() >= self.start),
    });
});
